import React, { useState, useEffect } from "react";
import {
  IconButton,
  Drawer,
  Box,
  List,
  Tooltip,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Avatar,
  AppBar,
  Toolbar,
  Typography,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CategoryIcon from "@mui/icons-material/Category";
import AppsIcon from "@mui/icons-material/Apps";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PersonIcon from "@mui/icons-material/Person";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import {removeLoginEncryptedLocalStorage} from '../utils/localStorage'
import { _toast } from "../utils";

// import LoadingBar from 'react-top-loading-bar';
const Header = ({ userRole, toggleDarkMode }) => {
  const location = useLocation(); // Get the current location
  const [activeRoute, setActiveRoute] = useState(location.pathname);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [orgImage, setOrgImage] = useState(""); // State to store the organization image URL
  const [orgImageDark, setOrgImageDark] = useState(""); // State to store the organization image URL

  const [fullName, setFullName] = useState(""); // State to store the organization image URL

  const navigate = useNavigate();
  const pathName = location.pathname; // Extract the current pathname
  const theme = useTheme();
  const drawerWidth = 240;
  
  const handleExitApp = () => {
    navigate("/klogin");
    removeLoginEncryptedLocalStorage()
    _toast('Logout Successfully', 'success');
  };
  useEffect(() => {
    setActiveRoute(location.pathname);
    const userData = localStorage.getItem("rbac-data");

    if (userData) {
      const parseData =  JSON.parse(userData);
      const Image=   parseData.org_Image || "" 
      const ImageDark=   parseData.org_Image_Dark || "" 
      setOrgImageDark(ImageDark)

      setOrgImage(Image);

    const  ProfileName =  `${parseData.first_name ? parseData.first_name:'' } ${parseData.last_name ? parseData.last_name :'' } `
    setFullName(ProfileName)
    }

  }, [location.pathname]);

  // handleExitAppROOT
  const handleExitAppROOT = () => {
    navigate("/");
    removeLoginEncryptedLocalStorage()
    _toast('Logout Successfully', 'success');
  };
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const getRouteTitle = (pathName) => {
    switch (pathName) {
      case "/application":
        return "Application";
      case "/organization":
        return "Organization";
      case "/user":
        return "User";
      case "/role":
        return "Role";
      case "/log":
        return "Logs";
      case "/profile":
        return "Profile";
      case "/table/application":
        return "Apps";

      default:
        return "RBAC"; // Default title for unknown routes
    }
  };

  const darkMode = localStorage.getItem("darkMode") === "true";
  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const randomAvatarColor = getRandomColor();

  function getInitials(fullName) {
    const nameArray = fullName.split(' ');
    const initials = nameArray.map(part => part.charAt(0).toUpperCase()).join('');
    return initials;
  }


  // Getting the initials of the user's name
  const userInitials = getInitials(fullName);

  return (
    <>
      <Box sx={{ flexGrow: 1, position: "sticky", top: 0, zIndex: 999 }}>
        <AppBar position="static">
          <Toolbar>
            <IconButton
              onClick={toggleDrawer}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, cursor: "pointer", userSelect: "none" }}
            >
              <Tooltip title="Role Based Access Control">
                <span>RBAC</span>
              </Tooltip>
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, userSelect: "none" }}
            >
              {getRouteTitle(pathName)}
            </Typography>

            <Tooltip title={fullName}>
            {orgImage  || orgImageDark ? (
              <img
                  src={darkMode ? (orgImageDark ? orgImageDark : orgImage) : (orgImage?orgImage:orgImageDark)}
                alt=""
                onClick={() => { navigate('/profile') }}
                style={{
                  width: "32px", // Set the width and height for the Avatar
                  height: "32px",
                  objectFit:'contain'
                }}
              />
            ) : (
              <Avatar
              onClick={() => { navigate('/profile') }}
                sx={{
                  backgroundColor: randomAvatarColor,
                  marginRight: "5px",
                
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                {userInitials}
              </Avatar>
            )}            
            </Tooltip>
            <IconButton onClick={toggleDarkMode} color="inherit">
              <Tooltip title={darkMode?"Enable Light Mode" : "Enable Dark Mode"}>
                {darkMode ? (
                  <WbSunnyIcon />
                ) : (
                  <Brightness4Icon />
                )}
              </Tooltip>
            </IconButton>
            {userRole === "ROOT" && (
              <Tooltip title="Exit">
                <IconButton onClick={handleExitAppROOT}>
                  <ExitToAppIcon
                    style={{ color: darkMode ? "inherit" : "white" }}
                  />
                </IconButton>
              </Tooltip>
            )}
            {userRole === "KERNAL" && (
              <Tooltip title="Exit">
                <IconButton onClick={handleExitApp}>
                  <ExitToAppIcon
                    style={{ color: darkMode ? "inherit" : "white" }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Toolbar>
        </AppBar>
        <Drawer
          variant="temporary"
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <IconButton onClick={toggleDrawer} sx={{ marginRight: "55px" }}>
              {drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
            <Typography>RBAC</Typography>
          </div>

          <Divider />
          <List>
            {/* Render drawer items based on userRole */}
            {userRole === "KERNAL" && (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate("/organization");
                      toggleDrawer();
                    }}
                    sx={{
                      backgroundColor:
                        activeRoute === "/organization"
                          ? theme.palette.action.selected
                          : "inherit",
                    }}
                  >
                    <ListItemIcon>
                      <CorporateFareIcon />
                    </ListItemIcon>
                    <ListItemText primary="Organization" />
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate("/application");
                      toggleDrawer();
                    }}
                    sx={{
                      backgroundColor:
                        activeRoute === "/application"
                          ? theme.palette.action.selected
                          : "inherit",
                    }}
                  >
                    <ListItemIcon>
                      <AppsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Application" />
                  </ListItemButton>
                </ListItem>
                <Divider />
               
              </>
            )}
            {userRole === "ROOT" && (
              <div>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate("/role");
                      toggleDrawer();
                    }}
                    sx={{
                      backgroundColor:
                        activeRoute === "/role"
                          ? theme.palette.action.selected
                          : "inherit",
                    }}
                  >
                    <ListItemIcon>
                      <CategoryIcon />
                    </ListItemIcon>
                    <ListItemText primary="Role" />
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItemButton
                  onClick={() => {
                    navigate("/user");
                    toggleDrawer();
                  }}
                  sx={{
                    backgroundColor:
                      activeRoute === "/user"
                        ? theme.palette.action.selected
                        : "inherit",
                  }}
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="User" />
                </ListItemButton>
                <Divider />
               
              </div>
            )}
          </List>
        </Drawer>
      </Box>
    </>
  );
};

export default Header;
